// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconAccountFocused = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35">
            <path
                fill="currentColor"
                d="M17,0 C7.61015666,0 0,7.61015666 0,17 C0,26.3898433 7.61015666,34 17,34 C26.3898433,34 34,26.3898433 34,17 C34,7.61015666 26.3898433,0 17,0 Z M17,8.5 C19.6409758,8.5 21.78125,10.6409369 21.78125,13.28125 C21.78125,15.9215621 19.6429679,18.0625 17,18.0625 C14.3596879,18.0625 12.21875,15.9215621 12.21875,13.28125 C12.21875,10.6409369 14.357031,8.5 17,8.5 Z M17,29.75 C13.4851177,29.75 10.2996098,28.3202735 7.98867208,26.0119916 C9.06445312,23.2355465 11.7207031,21.25 14.875,21.25 L19.125,21.25 C22.2819537,21.25 24.9382037,23.2342191 26.0113289,26.0119916 C23.7003902,28.3222656 20.5128902,29.75 17,29.75 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(IconAccountFocused);
